(function (angular, app) {
   "use strict";
    
   // Navigation
   angular.module(app.modules.ui.name)
      .directive(app.modules.ui.directives.navigation, NavDirective);
      
   NavDirective.$inject = [app.modules.ui.services.ui];
   
   function NavDirective(uiSvc) {
      return {
         restrict : "E"
         , templateUrl : "app/ui/directives/navigation.html"
         , link: function (scope, element, attrs) {
            scope.Menu = uiSvc.navigation;

            scope.f = {
               login: function () {
                  uiSvc.modal.open.login();
               }
            }
         }
      }
   }

}(angular, app));
